module.exports = __webpack_public_path__ + "static/media/moti_pak.eaa6da5a.jpg";